//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'
import {JSSDK, queryCoaOrder} from '@/api/index'

export default {
    //处理ios当前页面路径兼容问题（JSSDK接口传的参数）进入页面之前就处理
    beforeRouteEnter(to, from, next) {
        let u = navigator.userAgent;
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        if (isiOS && to.path !== location.pathname) {
            location.assign(to.fullPath)
        } else {
            next()
        }
    },
    mounted() {
        this.$vux.loading.show({
            text: '加载中...'
        });
        //当前页面地址
        let currUrl = window.location.href;
        //JSSDK接口调用
        JSSDK({
            url: currUrl
        }).then(res => {
            this.$vux.loading.hide();
            let info = res.data;
            wx.config({
                debug: false,
                appId: info.appId,
                timestamp: info.timestamp,
                nonceStr: info.nonStr,
                signature: info.signature,
                jsApiList: ['scanQRCode']
            });
        })
        //上个页面传过来的订货单号
        let t = this;
        t.deliveryNumber = t.$route.query.deliveryNumber;
    },
    data() {
        return {
            barcode: '',
            deliveryNumber: '',
            showErrMsg: false,
            msg: ''
        }
    },
    methods: {
        //coa钢瓶条形码查询
        queryCoaOrder() {
            let
                t = this,
                barcode = t.barcode,
                deliveryNumber = t.deliveryNumber;
            if (!barcode) {
                t.$vux.toast.text('钢瓶条形码不能为空', 'middle');
            } else {
                //钢瓶条形码coa查询接口
                queryCoaOrder({
                    barcode,
                    deliveryNumber,
                    choice: 1
                }).then(res => {
                    if (res.data.code === 0) {
                        let coab = JSON.stringify(res.data.data.coaDataDto);
                        //存储到本地
                        sessionStorage.setItem('coab', coab);
                        t.$router.push({
                            path: '/personalAnalyzeResult'
                        });
                    } else {
                        t.msg = res.data.msg;
                        t.showErrMsg = true;
                    }
                })
            }
        },
        //扫一扫
        scan() {
            let t = this;
            wx.scanQRCode({
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success: function (res) {
                    let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
                    t.barcode = result.split(',')[1];

                }
            });
        },
        //返回首页
        back_home() {
            let t = this;
            t.$router.replace('/index')
        },
        //弹出信息消失
        sure() {
            let t = this;
            t.showErrMsg = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/COA/personalBarCode.vue